var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplateMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 153,
    viewBox: "0 0 204 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 153,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 8,
    transform: "translate(60.5 12.5)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(30 30.5)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 51.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(68 30.5)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 51.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(106 30.5)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 109.5,
    y: 51.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(144 30.5)",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 51.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(30 70.5)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 91.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(68 70.5)",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 91.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(106 70.5)",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 109.5,
    y: 91.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(144 70.5)",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 91.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(30 110.5)",
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 131.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(68 110.5)",
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 131.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(106 110.5)",
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 109.5,
    y: 131.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(144 110.5)",
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 131.5,
    width: 23,
    height: 5,
    rx: 2.5,
    fill: "#C4C4C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateMenu);
export default __webpack_public_path__ + "static/media/TemplateMenu.bbe7e947c56c8458b4bf090b0c270ebe.svg";
export { ForwardRef as ReactComponent };